<div id="self-tour-verify-base-container" class="prospect-grid-container">
  <div id="self-tour-verify-base-container-top" class="text-3xl sm:font-rhetorik-sans sm:text-40px mb-8">
    Self Tour Verification
  </div>
  <div id="specific-verify-step-container"><router-outlet></router-outlet></div>
</div>
